import React, { useEffect } from "react"
import classNames from "classnames"
import Glide from "@glidejs/glide"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./Testimonials.module.scss"
import Button from "../../../UI/Button/Button"
import Swipe from "../../../UI/Swipe"

const reviewList = [
	{ review: "\"We were impressed with their timely responses and reliability.\"", name: "Femina Ernest", jobTitle: "Head of Digital, B2Connect" },
	{ review: "\"We are happy with everything.\"", name: "Tatiana Kononova", jobTitle: "Head of Development, Maxifier" },
	{ review: "\"The level of their AI and ML expertise was high.\"", name: "Anonymous", jobTitle: "Partner, abcb" },
	{ review: "\"They were always available and very willing to support.\"", name: "Anca", jobTitle: "Founder, NexusMentis" },
	{ review: "\"We've been pleased with the project management, communication, and collaboration.\"", name: "Anonymous", jobTitle: "Managing Partner, Venture Capital Company" },
];


const Testimonials: React.FC = () => {
	const intl = useIntl()

	useEffect(() => {
		if (styles?.testimonials && document.querySelector(`.${styles.testimonials}`)) {
			const glide = new Glide(`.${styles.testimonials}`, {
				type: "carousel",
				keyboard: false,
				autoplay: false,
				hoverpause: false,
				animationTimingFunc: "linear",
				dragThreshold: 20,
				peek: {
					before: 0,
					after: 368
				},
				startAt: 0,
				perView: 2,
				gap: 24,
				direction: intl.locale === "ar" ? "rtl" : "ltr",
				breakpoints: {
					1400: {
						perView: 2,
						peek: {
							before: 0,
							after: 220
						},
					},
					800: {
						perView: 1,
						peek: {
							before: 0,
							after: 50
						},
					},
				},
			})
			glide.mount()
		}
	})

	const testimonialsClasses = classNames(styles.testimonials, "glide")
	const testimonialsWrapperClasses = classNames(styles.wrapper, "glide__track")
	const testimonialsListClasses = classNames(styles.list, "glide__slides")
	const testimonialsItemClasses = classNames(styles.listItem, "glide__slide")

	return (
		<section className={testimonialsClasses}>
			<div className={styles.titleBlock}>
				<h2 className={styles.title}>	{intl.formatMessage({ id: "index.testimonials" })}</h2>
				<Swipe />
			</div>
			<div className={testimonialsWrapperClasses} data-glide-el="track">
				<ul className={testimonialsListClasses}>

					{
						reviewList.map((item, index) => (
							<li key={index} className={testimonialsItemClasses}>
								<h3 className={styles.listReview}>{item.review}</h3>
								<div className={styles.listBottom}>
									<div className={styles.nameBlock}>
										<h4 className={styles.name}>{item.name}</h4>
										<p className={styles.jobTitle}>{item.jobTitle}</p>
									</div>
									<Button to="https://clutch.co/profile/inventale-custom-projects#reviews" variant="border" size="small" noFill>
										Read Full Review
									</Button>
								</div>
							</li>
						))
					}

				</ul>
			</div>
		</section>
	);
}

export default Testimonials;
